import type { CreateBreadcrumbsSchemaProps } from "./createBreadcrumbsSchema.d";

const createBreadcrumbsSchema = (
  firstElementUrl: CreateBreadcrumbsSchemaProps["firstElementUrl"],
  currentPositionName: CreateBreadcrumbsSchemaProps["currentPositionName"],
  currentUrl: CreateBreadcrumbsSchemaProps["currentUrl"],
  parentPositionName: CreateBreadcrumbsSchemaProps["parentPositionName"],
  parentUrl: CreateBreadcrumbsSchemaProps["parentUrl"],
) => JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "AirHelp",
        item: firstElementUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: parentPositionName || currentPositionName,
        item: parentPositionName ? parentUrl : currentUrl,
      },
      parentPositionName && {
        "@type": "ListItem",
        position: 3,
        name: currentPositionName,
        item: currentUrl,
      },
    ],
  });

export default createBreadcrumbsSchema;
